/* ═══════════════════════════════════════════════════════════════════════════════════════════════════════════
   bks-avis.js — SYSTÈME D'AVIS (zone avis, chantier « système d'avis », 12/10/2026, site/outils/1210/avis/)
   1. Confort de lecture : « Lire la suite » (avis longs), « Voir plus d'avis » (fiche), filtre par note et pagination
      par 24 (page avis). Sans JS, tout reste lisible : rien n'est masqué tant que ce script n'a pas pris la main.
   2. Rafraîchissement EN DIRECT depuis l'API publique de la Société des Avis Garantis (celle du widget officiel, CORS *),
      seulement si la réponse est COHÉRENTE (total = nombre d'avis, notes 1-5, répartition = total) ; sinon le relevé daté
      rendu par le serveur reste affiché. Seuls les avis PLUS RÉCENTS que le relevé sont ajoutés ; les chiffres ne
      baissent jamais en direct (le compteur affiché est un minimum garanti par la source).
      La clé PUBLIQUE est lue dans la page (script #grc-widgets du thème) : elle n'est écrite nulle part ici.
      Textes insérés par textContent uniquement (aucun HTML venu de l'API). Signature telle que la SAG la publie
      (« Prénom I. » ou « Acheteur Vérifié »). Si l'API compte MOINS que le relevé, le relevé daté reste (jamais « vérifié »).
   ═══════════════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__bksAvis) return;
  window.__bksAvis = true;

  var API = 'https://api.guaranteed-reviews.com/public/v3/reviews/';
  var CACHE = 'bks-avis-site-v1';
  var PAR_PAGE = 24;

  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function aujourdhui() { var d = new Date(); return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); }
  function dateFr(iso) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? m[3] + '/' + m[2] + '/' + m[1] : ''; }
  function virgule(n) { return String(n).replace('.', ','); }

  /* signature (même règle que R0-commun.js) : « Acheteur Vérifié » de la SAG gardé tel quel ; une signature déjà au format
     publié (prénom, ou prénoms + initiale) gardée telle quelle ; sinon « Prénom Nom » → « Prénom N. » (jamais un nom complet) */
  var MAJ = 'A-ZÀÂÄÇÉÈÊËÎÏÔÖÙÛÜŸÆŒ', LET = 'A-Za-zÀ-ÖØ-öø-ÿŒœ\'’-';
  var RE_SIG_OK = new RegExp('^(Client|Acheteur Vérifié|[' + MAJ + '][' + LET + ']*|[' + MAJ + '][' + LET + ']*( [' + MAJ + '][' + LET + ']*){0,2} [' + MAJ + ']\\.)$');
  function casse(m) { return (m === m.toUpperCase() || m === m.toLowerCase()) ? m.toLowerCase().replace(/(^|[-'’])(\S)/g, function (x, a, b) { return a + b.toUpperCase(); }) : m; }
  function signature(c) {
    var t = String(c == null ? '' : c).replace(/\s+/g, ' ').trim().replace(/[.,;]+$/, function (m) { return m.indexOf('.') >= 0 ? '.' : ''; });
    if (!t) return 'Client';
    if (/^acheteur\s+v[ée]rifi[ée]\.?$/i.test(t)) return 'Acheteur Vérifié';
    if (RE_SIG_OK.test(t)) return t;
    var mots = t.split(' ');
    if (mots.length === 1) return casse(mots[0].replace(/\.$/, ''));
    var der = mots[mots.length - 1];
    if (/^[A-Za-zÀ-ÿ]\.?$/.test(der)) return mots.slice(0, -1).slice(0, 3).map(casse).join(' ') + ' ' + der.charAt(0).toUpperCase() + '.';
    var l = (der.match(/[A-Za-zÀ-ÿ]/) || [])[0];
    return l ? casse(mots[0]) + ' ' + l.toUpperCase() + '.' : casse(mots[0]);
  }

  /* ── 1. confort de lecture ─────────────────────────────────────────────────────────────────────────────── */
  function lireLaSuite(racine) {
    $$('.bks-avis-carte--long', racine).forEach(function (c) {
      var p = c.querySelector('.bks-avis-carte__txt p'), b = c.querySelector('.bks-avis-carte__suite');
      if (!p || !b || b.__bks) return;
      b.__bks = true;
      if (p.scrollHeight > p.clientHeight + 2) b.hidden = false;
      b.addEventListener('click', function () {
        var ouvert = c.classList.toggle('is-ouvert');
        b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        b.textContent = ouvert ? 'Réduire' : 'Lire la suite';
      });
    });
  }

  function voirPlus(racine) {
    var b = racine.querySelector('[data-bks-avis-plus]');
    if (!b) return;
    var boite = racine.querySelector('[data-bks-avis-plus-boite]');
    var cachees = function () { return (boite ? boite.querySelectorAll('.bks-avis-carte').length : 0) + $$('[data-bks-avis-liste="site"] > .bks-avis-carte', racine).filter(function (c) { return c.offsetParent === null; }).length; };
    if (!cachees() && !racine.classList.contains('is-ouvert')) return;
    b.hidden = false;
    b.addEventListener('click', function () {
      var ouvert = racine.classList.toggle('is-ouvert');
      b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      b.textContent = ouvert ? 'Voir moins d’avis' : 'Voir plus d’avis';
      if (ouvert) lireLaSuite(racine);
    });
  }

  function pagePilote(racine) {
    var liste = racine.querySelector('[data-bks-avis-liste="page"]');
    if (!liste) return null;
    var filtre = racine.querySelector('[data-bks-avis-filtre]');
    var etat = racine.querySelector('[data-bks-avis-etat]');
    var encore = racine.querySelector('[data-bks-avis-encore]');
    var note = 'tout', montres = PAR_PAGE;
    function cartes() { return $$('.bks-avis-carte', liste); }
    function rendre(annoncer) {
      var c = cartes(), vis = c.filter(function (x) { return note === 'tout' || x.getAttribute('data-note') === note; });
      c.forEach(function (x) { x.classList.remove('is-vu'); });
      vis.slice(0, montres).forEach(function (x) { x.classList.add('is-vu'); });
      racine.classList.add('is-pilote');
      if (encore) { encore.hidden = vis.length <= montres; encore.textContent = 'Afficher ' + Math.min(PAR_PAGE, vis.length - montres) + ' avis de plus'; }
      if (etat && annoncer) etat.textContent = Math.min(montres, vis.length) + ' avis affichés sur ' + vis.length + (note === 'tout' ? '' : ' notés ' + note + ' sur 5') + '.';
      lireLaSuite(liste);
    }
    /* compteurs du filtre : rendus par le serveur ; recomptés seulement quand le direct ajoute des cartes */
    function compter() {
      if (!filtre) return;
      var c = cartes();
      $$('button', filtre).forEach(function (b) {
        var n = b.getAttribute('data-note'), k = n === 'tout' ? c.length : c.filter(function (x) { return x.getAttribute('data-note') === n; }).length;
        var s = b.querySelector('.bks-avis-n') || b.appendChild(document.createElement('span'));
        s.className = 'bks-avis-n'; s.textContent = ' (' + k + ')';
      });
    }
    if (filtre) {
      filtre.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        note = b.getAttribute('data-note'); montres = PAR_PAGE;
        $$('button', filtre).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        rendre(true);
      });
    }
    if (encore) encore.addEventListener('click', function () {
      var avant = $$('.bks-avis-carte.is-vu', liste).length;
      montres += PAR_PAGE; rendre(true);
      var premiere = $$('.bks-avis-carte.is-vu', liste)[avant];
      if (premiere) { premiere.setAttribute('tabindex', '-1'); premiere.focus({ preventScroll: false }); }
    });
    rendre(false);
    return { rendre: rendre, compter: compter };
  }

  /* ── 2. direct ─────────────────────────────────────────────────────────────────────────────────────────── */
  function cle() {
    var s = document.getElementById('grc-widgets') || document.querySelector('script[data-public-key][src*="guaranteed-reviews"]');
    var k = s && s.getAttribute('data-public-key');
    return k && /^[0-9a-f]{20,64}$/i.test(k) ? k : null;
  }
  function coherent(d) {
    if (!d || !d.ratings || !Array.isArray(d.reviews)) return false;
    var t = +d.ratings.total, a = +d.ratings.average, dist = d.ratings.distribution || {}, s = 0;
    for (var k = 1; k <= 5; k++) s += +(dist[k] || 0);
    if (!(t > 0) || t !== d.reviews.length || s !== t || !(a >= 1 && a <= 5)) return false;
    return d.reviews.every(function (r) { return r && +r.r >= 1 && +r.r <= 5 && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(String(r.date || '')); });
  }
  var promesse = null;
  function lireSite() {
    if (promesse) return promesse;
    var k = cle();
    if (!k || !window.fetch) return (promesse = Promise.resolve(null));
    try { var c = JSON.parse(sessionStorage.getItem(CACHE) || 'null'); if (c && Date.now() - c.t < 30 * 60 * 1000 && coherent(c.d)) return (promesse = Promise.resolve(c.d)); } catch (e) { /* stockage indisponible */ }
    var ctl = window.AbortController ? new AbortController() : null;
    var minuterie = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
    promesse = fetch(API + k + '/site', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(minuterie);
        if (!coherent(d)) return null;
        try { sessionStorage.setItem(CACHE, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* stockage indisponible */ }
        return d;
      })
      .catch(function () { clearTimeout(minuterie); return null; });
    return promesse;
  }

  function carteDepuis(modele, r) {
    var c = modele.cloneNode(true);
    var odate = /^(19|20)\d{2}-\d{2}-\d{2}/.test(String(r.odate || '')) ? String(r.odate).slice(0, 10) : '';
    var date = String(r.date).slice(0, 10);
    c.className = 'bks-avis-carte is-neuf';
    c.setAttribute('data-note', String(+r.r));
    c.setAttribute('data-cle', String(r.date).slice(0, 16) + '|' + odate + '|' + (+r.r));
    $$('.bks-avis-carte__suite, .bks-avis-carte__rep, .bks-avis-carte__medias', c).forEach(function (x) { x.parentNode.removeChild(x); });
    var e = c.querySelector('.bks-avis-etoiles'); if (e) e.style.setProperty('--bks-avis-p', (+r.r * 20) + '%');
    var n = c.querySelector('.bks-avis-carte__note-t'); if (n) { n.textContent = ''; var vh = document.createElement('span'); vh.className = 'bks-avis-vh'; vh.textContent = 'Note : '; n.appendChild(vh); n.appendChild(document.createTextNode(+r.r + '/5')); }
    var p = c.querySelector('.bks-avis-carte__txt p'); if (p) p.textContent = String(r.txt || '').trim();
    var s = c.querySelector('.bks-avis-carte__sig'); if (s) s.textContent = signature(r.c);
    var d = c.querySelector('.bks-avis-carte__dates');
    if (d) {
      d.textContent = 'Avis du ';
      var t1 = document.createElement('time'); t1.setAttribute('datetime', date); t1.textContent = dateFr(date); d.appendChild(t1);
      if (odate) { d.appendChild(document.createTextNode(' · commande du ')); var t2 = document.createElement('time'); t2.setAttribute('datetime', odate); t2.textContent = dateFr(odate); d.appendChild(t2); }
    }
    if (r.reply && String(r.reply).trim()) {
      var renvoi = delaiPerime(r.reply);
      var rep = document.createElement('div'); rep.className = 'bks-avis-carte__rep' + (renvoi ? ' bks-avis-carte__rep--renvoi' : '');
      var rt = document.createElement('p'); rt.className = 'bks-avis-carte__rep-t'; rt.textContent = 'Réponse de Bike Sellier' + (r.rdate ? ' · ' + dateFr(String(r.rdate)) : '');
      var rx = document.createElement('p'); rx.className = 'bks-avis-carte__rep-x';
      if (renvoi) {
        /* même règle que R0 delaiPerime / bks-avis-carte.liquid : une réponse qui chiffre un délai autre que « 3 à 5 semaines »
           n'est pas recopiée ; renvoi vers l'attestation, où elle reste lisible en entier */
        rx.appendChild(document.createTextNode('Cette réponse indiquait un délai qui a changé depuis : aujourd’hui, notre délai est de 3 à 5 semaines. '));
        var a = document.createElement('a'); a.href = 'https://www.societe-des-avis-garantis.fr/bike-sellier/'; a.target = '_blank'; a.rel = 'noopener';
        a.appendChild(document.createTextNode('Lire la réponse en entier sur l’attestation'));
        var vh = document.createElement('span'); vh.className = 'bks-avis-vh'; vh.textContent = ' (nouvel onglet)'; a.appendChild(vh);
        rx.appendChild(a);
      } else rx.textContent = String(r.reply).trim();
      rep.appendChild(rt); rep.appendChild(rx); c.querySelector('.bks-avis-carte__fig').appendChild(rep);
    }
    return c;
  }
  /* délai chiffré autre que « 3 à 5 semaines » (même règle que R0-commun.js) */
  function delaiPerime(t) {
    var m = String(t || '').match(/\b\d+\s*(?:(?:à|a|-|–|et)\s*\d+\s*)?(?:jours?|semaines?|mois)\b/gi) || [];
    for (var i = 0; i < m.length; i++) if (!/^3\s*à\s*5\s*semaines$/i.test(m[i].replace(/^\s+|\s+$/g, ''))) return true;
    return false;
  }

  function appliquer(racine, d, pilote) {
    var dernier = racine.getAttribute('data-dernier') || '';
    var neufs = d.reviews.filter(function (r) { return String(r.date).slice(0, 16) > dernier; })
      .sort(function (a, b) { return String(b.date).localeCompare(String(a.date)); });
    var res = racine.querySelector('.bks-avis__resume');
    var rel = racine.querySelector('[data-bks-avis-v="releve"]');
    /* la source compte MOINS que le relevé + les avis plus récents (avis retiré à la source, API en retard) : rien n'est
       changé et rien n'est dit « vérifié » — le relevé daté reste affiché (correction du 13/10, tour 1) */
    if (+d.ratings.total < (+racine.getAttribute('data-nb') || 0) + neufs.length) return;
    if (!neufs.length) {
      /* même longueur que « Relevé à la source le jj/mm/aaaa » : la ligne ne passe pas à la ligne (aucun saut de mise en page) */
      if (rel && !rel.__bks) { rel.__bks = true; rel.textContent = 'Vérifié en direct le ' + aujourdhui(); }
      return;
    }
    /* chiffres : relevé + avis plus récents ; le compteur ne descend jamais sous l'API */
    var n = (res && res.getAttribute('data-bks-avis-n') || '').split(',').map(Number);
    if (n.length !== 5 || n.some(isNaN)) return;
    neufs.forEach(function (r) { n[+r.r - 1]++; });
    var tot = n.reduce(function (a, b) { return a + b; }, 0);
    var moy = n.reduce(function (a, b, i) { return a + b * (i + 1); }, 0) / tot;
    var nb = Math.max((+racine.getAttribute('data-nb') || 0) + neufs.length, +d.ratings.total);
    var note10 = (Math.round(moy * 20) / 10).toFixed(1);
    $$('[data-bks-avis-v="nb"]').forEach(function (x) { x.textContent = String(nb); });
    $$('[data-bks-avis-v="note10"]').forEach(function (x) { x.textContent = virgule(note10); });
    $$('[data-bks-avis-v="etoiles"]').forEach(function (x) { x.style.setProperty('--bks-avis-p', Math.round(+note10 * 10) + '%'); x.setAttribute('aria-label', 'Note moyenne : ' + virgule((+note10 / 2).toFixed(1)) + ' sur 5'); });
    for (var k = 1; k <= 5; k++) {
      var pc = Math.round(n[k - 1] / tot * 100);
      $$('[data-bks-avis-v="p' + k + '"]', racine).forEach(function (x) { x.textContent = String(pc); });
      $$('[data-bks-avis-barre="' + k + '"]', racine).forEach(function (x) { x.style.width = pc + '%'; });
    }
    if (res) res.setAttribute('data-bks-avis-n', n.join(','));
    racine.setAttribute('data-nb', String(nb));
    racine.setAttribute('data-dernier', String(neufs[0].date).slice(0, 16));
    if (rel) rel.textContent = 'Mis à jour en direct le ' + aujourdhui();   /* court : la ligne ne passe pas à la ligne */
    /* cartes : seulement les avis avec texte, du plus récent au plus ancien */
    var avecTexte = neufs.filter(function (r) { return String(r.txt || '').trim(); });
    var liste = racine.querySelector('[data-bks-avis-liste="page"]') || racine.querySelector('[data-bks-avis-liste="site"]');
    var modele = liste && liste.querySelector('.bks-avis-carte');
    if (!modele || !avecTexte.length) return;
    var deja = {};
    $$('.bks-avis-carte', racine).forEach(function (x) { deja[x.getAttribute('data-cle')] = 1; });
    avecTexte.slice().reverse().forEach(function (r) {
      var c = carteDepuis(modele, r);
      if (deja[c.getAttribute('data-cle')]) return;
      liste.insertBefore(c, liste.firstChild);
    });
    if (liste.getAttribute('data-bks-avis-liste') === 'site') {
      var plus = racine.querySelector('[data-bks-avis-liste="site-plus"]');
      var lis = $$('.bks-avis-carte', liste);
      while (plus && lis.length > 3) { var x = lis.pop(); plus.insertBefore(x, plus.firstChild); }
    }
    if (pilote) { pilote.compter(); pilote.rendre(false); }
    lireLaSuite(racine);
  }

  function direct(racine, pilote) {
    lireSite().then(function (d) { if (d) appliquer(racine, d, pilote); });
  }

  /* ── démarrage ─────────────────────────────────────────────────────────────────────────────────────────── */
  function init() {
    $$('[data-bks-avis="fiche"], [data-bks-avis="page"]').forEach(function (racine) {
      if (racine.__bks) return;
      racine.__bks = true;
      racine.classList.add('bks-avis--js');
      lireLaSuite(racine);
      voirPlus(racine);
      var pilote = racine.getAttribute('data-bks-avis') === 'page' ? pagePilote(racine) : null;
      if (pilote || !('IntersectionObserver' in window)) { direct(racine, pilote); return; }
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); direct(racine, null); }
      }, { rootMargin: '600px 0px' });
      io.observe(racine);
    });
    /* le résumé officiel sous le titre de la fiche mène au bloc BKS (décision D7) */
    var bloc = document.getElementById('bks-avis');
    $$('.grc-product-summary').forEach(function (s) {
      if (!bloc || s.__bks) return;
      s.__bks = true;
      s.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); bloc.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
